import { render, staticRenderFns } from "./CoPalermoLogo.vue?vue&type=template&id=e781a05a&scoped=true"
import script from "./CoPalermoLogo.vue?vue&type=script&lang=js"
export * from "./CoPalermoLogo.vue?vue&type=script&lang=js"
import style0 from "./CoPalermoLogo.vue?vue&type=style&index=0&id=e781a05a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e781a05a",
  null
  
)

export default component.exports